// extracted by mini-css-extract-plugin
module.exports = {"A2":"A2_A2__kJeNq"};